const validatePhone = (phone: string): boolean => {
  const regexp = /^[\s()+-]*([0-9][\s()+-]*){6,20}$/;
  return regexp.test(phone);
};
export default validatePhone;
